import React, { useEffect, useRef } from "react";
import {
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  Button,
} from "@chakra-ui/react";

interface ErrorAlertProps {
  isOpen: boolean;
  onConfirm: () => void;
  header: string;
  body: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = (props) => {
  const { isOpen: isDialogOpen, onOpen, onClose } = useDisclosure();
  const { isOpen, onConfirm, header, body } = props;
  const cancelRef = useRef(null);

  useEffect(() => {
    isOpen ? onOpen() : onClose();
  }, [isOpen]);

  const handleConfirmClick = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog
      motionPreset="slideInBottom"
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      isOpen={isDialogOpen}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>{header}</AlertDialogHeader>
        <AlertDialogBody>{body}</AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={cancelRef} onClick={handleConfirmClick}>
            OK
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ErrorAlert;
